module.exports = __webpack_public_path__ + "uKAwi6M3jJIjqSQpK/tandc_icon.svg";